export default class CommandeApiDriveService {
  path = "/api/me/smartlistes";

  constructor(httpApi) {
    this.httpApi = httpApi;
  }

  /**
   * Liste des produits habituels du client connecté
   */
  async smartliste(magasinId) {
    const config = {
      ...this.httpApi.getConfig(), ...{ params: { magasin_id: magasinId } }
    };
    const res = await this.httpApi.get(this.path, config);
    return res.data;
  }


  /**
   * Suppression d'un produit d'une liste de courses
   * @param {String} liste_id
   * @param {String} item_id
   */
  async deleteItem(liste_id, item_id) {
    const res = await this.httpApi.delete(`${this.path}/${liste_id}/smartlisteItem/${item_id}`);
    return res.data;
  }

  /**
   * Suppression en masse de produits d'une liste de courses
   * @param {Arrays} items_id
   */
  async deleteItems(items_id) {
    const data = {
      smartlisteItems: items_id
    }
    const res = await this.httpApi.post(`${this.path}/deleteItems`, data);
    return res.data;
  }
}
